// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73deade9","239":"8ae11e7d","732":"fe1c461e"}[chunkId] + ".chunk.js";
};